import React from 'react';
import {Field, getIn} from 'formik';
export const ErrorMessage = ({name, render}) => {
  return (
    <Field
      name={name}
      render={({form}) => {
        const error = getIn(form.errors, name);
        const touch = getIn(form.touched, name);
        return render(touch && error ? error : null);
      }}
    />
  );
};
